/* Rough Old Glass – framed mirror estimator fixes (Oct 2026)
   1. Touch screens: remove hover image swaps so a single tap selects a tile
      (iOS treats the first tap on an element with hover effects as a "hover").
   2. Phone/browser back button steps back through the estimator instead of
      doing nothing / leaving the page. */
(function () {
  function init($) {
    if (!document.querySelector('.frames-bespoke')) return;

    var isTouch = (window.matchMedia && window.matchMedia('(hover: none)').matches) ||
                  ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    if (isTouch) {
      document.documentElement.classList.add('rog-touch');
      $(window).on('load', function () {
        $('.frame-element .image').off('mouseenter mouseleave');
      });
    }

    function currentStep() { return $('.step:not(.hideStep)').attr('name'); }

    function recordStep() {
      var s = currentStep();
      if (!s) return;
      var st = history.state || {};
      try {
        if (!st.rogStep) {
          history.replaceState({ rogStep: s }, '', location.href);
        } else if (st.rogStep !== s) {
          history.pushState({ rogStep: s }, '', location.href);
        }
      } catch (e) {}
    }

    $(function () {
      try { history.replaceState({ rogStep: currentStep() || 'sizeSection' }, '', location.href); } catch (e) {}
    });

    $(document).on('click', '.total-submit .next, .mobile-header .next, .mobile-header .back, .frame-nav li', function () {
      setTimeout(recordStep, 0);
    });

    window.addEventListener('popstate', function (e) {
      var target = e.state && e.state.rogStep;
      /* customiserUI is a top-level const in inspira-script.js, so it is a
         global binding but not a property of window */
      var ui = (typeof customiserUI !== 'undefined') ? customiserUI : null;
      if (!target || !ui) return;
      if (!$('.step[name="' + target + '"]').length) return;
      ui.changeStep(target);
      if (window.inspira && inspira.scrollTop) inspira.scrollTop();
    });
  }

  if (window.jQuery) {
    init(window.jQuery);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.jQuery) init(window.jQuery);
    });
  }
})();
